/**
 * Created by Andrey Popov on 20.10.20
 */

const SimpleMethaDataProvider = function () {
    this.reset();
};

SimpleMethaDataProvider.prototype.reset = function () {
    this.data = undefined;
};

SimpleMethaDataProvider.prototype.getData = function () {
    if (this.data) {
        return this.data;
    }

    if (!["scramble", "tripeaks"].includes(cleverapps.config.name)) {
        this.data = {};
        return this.data;
    }

    const data = {};

    const addBgLevel = function (episode, level, bgIndex) {
        data[`${episode}_${level}`] = {
            text: `BG${bgIndex}`,
            icon: bundles.admin.frames.feature_bg,
            tooltip: Messages.has(`background_name_${bgIndex}`) ? Messages.get(`background_name_${bgIndex}`) : ""
        };
    };

    addBgLevel(0, 0, 0);

    const episodesToCheck = levels.User.CalcEpisodesAmount(true);

    let stars = 0;
    let current = 0;

    for (let episodeNo = 0; episodeNo < episodesToCheck; episodeNo++) {
        const bundleName = AdminEpisode.BundleId(episodeNo);
        const bundle = bundles[bundleName];
        if (bundle.meta.episode && bundle.meta.episode.levels) {
            for (let levelNo = 0; levelNo < Math.min(bundle.meta.episode.levels.length, AdminEpisode.LEVELS_PER_EPISODE); levelNo++) {
                if (stars >= cleverapps.meta.getSelectedLocation().getRequiredProgress()) {
                    stars = 0;
                    current++;

                    addBgLevel(episodeNo, levelNo, current);
                }

                stars += Level.IsHardTag(bundle.meta.episode.levels[levelNo].tag) ? 3 : 1;
            }
        }
    }

    this.data = data;
    return this.data;
};

SimpleMethaDataProvider.prototype.getEvents = function (episodeNo, levelNo) {
    const data = this.getData();

    const event = data[`${episodeNo}_${levelNo}`];
    return event ? [event] : [];
};
